//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

export default {
	name: 'select-options',
	props: ['options', 'current'],
	data: () => ({
		selected: '',
		isOpen: false,
	}),
	watch: {
		current(current) {
			this.selected = current
		},
	},
	methods: {
		selectOption(opt) {
			this.selected = opt
			this.$emit('selected', opt)
			this.isOpen = false
		},
		openOptions() {
			this.isOpen = true
		},
	},
	mounted() {
		this.selected = this.options[0]
	},
}
